import { render } from "./edit-patient.vue?vue&type=template&id=ebd023dc"
import script from "./edit-patient.vue?vue&type=script&lang=js"
export * from "./edit-patient.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__